export const contactsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const searchBoxStyles = {
  padding: '12px 16px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  flexShrink: 0,
};

export const searchInputStyles = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: ({ palette }) => palette.background.secondary,
    borderRadius: '8px',
    fontSize: '14px',
    '& input': {
      padding: '8px 12px',
    },
    '& fieldset': {
      borderColor: ({ palette }) => palette.border.default,
    },
  },
};

export const contactsListStyles = {
  flex: 1,
  overflow: 'auto',
};

export const contactRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '10px 16px',
  cursor: 'pointer',
  transition: 'background-color 0.15s',
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
  height: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const contactRowDisabledStyles = {
  ...contactRowStyles,
  cursor: 'default',
  opacity: 0.5,
  '&:hover': {
    backgroundColor: 'transparent',
  },
};

export const contactStatusDotStyles = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
};

export const contactInfoStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  flex: 1,
};

export const contactNameStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: ({ palette }) => palette.text.strong,
};

export const contactStatusLabelStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const emptyStateStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  padding: '24px',
  gap: '8px',
};

export const emptyStateIconStyles = {
  color: ({ palette }) => palette.text.disabled,
};

export const emptyStateTextStyles = {
  textAlign: 'center',
  color: ({ palette }) => palette.text.placeholder,
};

export const loadingContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
};

export const searchIconStyles = { fontSize: 20, color: 'text.secondary' };
